/**
 * La demande du code parent, d'où qu'elle vienne (HARMONIA-87).
 *
 * L'entrée en mode enfant vit dans la barre parent, la sortie dans les écrans
 * enfant, et ni l'une ni l'autre ne peut porter une feuille qui leur survive :
 * la sortie change justement de section. Une seule feuille, montée une fois
 * dans App.vue (ParentCodeSheet), répond donc à tout le monde ; on lui demande
 * le code par une promesse.
 */
import { reactive, readonly } from 'vue'

export type ParentCodeMode = 'create' | 'verify'
/** `forgot` : le parent a demandé à se déconnecter faute de code. */
export type ParentCodeResult = 'ok' | 'cancelled' | 'forgot'

const state = reactive({
  open: false,
  mode: 'verify' as ParentCodeMode,
  /** Change à chaque demande : la feuille repart d'un formulaire vide. */
  requestId: 0,
})

let pending: ((result: ParentCodeResult) => void) | null = null

/** Ouvre la feuille et attend la réponse. Une demande en cours est annulée. */
export function requestParentCode(mode: ParentCodeMode): Promise<ParentCodeResult> {
  pending?.('cancelled')
  state.mode = mode
  state.requestId += 1
  state.open = true
  return new Promise((resolve) => { pending = resolve })
}

/** Appelé par la feuille seulement. */
export function settleParentCode(result: ParentCodeResult): void {
  state.open = false
  const resolve = pending
  pending = null
  resolve?.(result)
}

export function useParentCodeGateState() {
  return readonly(state)
}
